import { render, staticRenderFns } from "./CreateEditUser.vue?vue&type=template&id=039c12d1"
import script from "./CreateEditUser.vue?vue&type=script&lang=js"
export * from "./CreateEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports